/**
 * Resolve o SERVIÇO DE API a partir da bancarizadora, para as telas de consulta
 * de FGTS — que rodam antes de existir proposta.
 *
 * Não confundir com o registry de `components/proposal`, que resolve CÉLULA a
 * partir do par (produto, bancarizadora) e só vale depois que há proposta. O
 * que migrou para lá foi o desligamento por bancarizadora, hoje em `lifecycle`;
 * o dispatcher abaixo continua sendo o único caminho destas telas.
 */

import config from '@/data/config';

import {
  fgtsBmpAPI,
  fgtsBmsAPI,
  fgtsCartosAPI,
  fgtsCelcoinAPI,
  fgtsQiTechAPI,
} from '@/services';

export const DISABLED_SUPPLIER_IDS = [];
export const MASS_CONSULT_DISABLED_SUPPLIER_IDS = [config.SUPPLIER_ID_BMS];

export const SUPPLIER_DISABLED_MESSAGE = 'Consultas a este fornecedor estão temporariamente suspensas.';

/**
 * Bancarizadora -> serviço do par FGTS.
 *
 * Cada entrada é a esteira FGTS daquele banco, então quem consome não precisa
 * mais dizer qual produto quer: o antigo `celcoin` servia FGTS e CLT na mesma
 * função e exigia uma flag `isFGTS` no payload.
 */
const SUPPLIER_API_BY_ID = {
  [config.SUPPLIER_ID_QITECH]: fgtsQiTechAPI,
  [config.SUPPLIER_ID_BMP]: fgtsBmpAPI,
  [config.SUPPLIER_ID_BMS]: fgtsBmsAPI,
  [config.SUPPLIER_ID_CARTOS]: fgtsCartosAPI,
  [config.SUPPLIER_ID_CELCOIN]: fgtsCelcoinAPI,
};

export function isSupplierDisabled(supplierId) {
  return DISABLED_SUPPLIER_IDS.includes(supplierId);
}

export function isSupplierDisabledForMassConsult(supplierId) {
  return MASS_CONSULT_DISABLED_SUPPLIER_IDS.includes(supplierId);
}

export function getSupplierApi(supplierId) {
  return SUPPLIER_API_BY_ID[supplierId] || null;
}
